import React from 'react';
import { User } from 'lucide-react';

interface UserAvatarProps {
  email: string;
  imageUrl?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function UserAvatar({ email, imageUrl, size = 'md' }: UserAvatarProps) {
  const sizeClasses = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg'
  };

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={email}
        className={`${sizeClasses[size]} rounded-full object-cover`}
      />
    );
  }

  const initial = email[0].toUpperCase();
  const colors = [
    'bg-blue-500',
    'bg-green-500',
    'bg-yellow-500',
    'bg-red-500',
    'bg-purple-500'
  ];
  const colorIndex = email.length % colors.length;
  const bgColor = colors[colorIndex];

  return (
    <div className={`${sizeClasses[size]} ${bgColor} rounded-full flex items-center justify-center text-white font-medium`}>
      {initial}
    </div>
  );
}